import { Box, FormLabel, Stack, Typography } from '@mui/material';
import { ObjectFieldTemplateProps } from '@rjsf/core';

export default function TableContainerTemplate({ title, properties, uiSchema }: ObjectFieldTemplateProps) {
  if (!uiSchema['ui:headers']) {
    return null;
  }

  return (
    <Stack spacing={3}>
      {title && <FormLabel>{title}</FormLabel>}
      <Stack spacing={1}>
        <Stack spacing={3} direction="row">
          {uiSchema['ui:headers'].map((header) => (
            <Box flex={1}>
              <Typography variant="h5">{header}</Typography>
            </Box>
          ))}
        </Stack>
        {properties.map((property) => property.content)}
      </Stack>
    </Stack>
  );
}
